<template>
<div>
    <div class="panel">
        <div class="panel-heading">
            <div class="panel-label">
                <h3 v-if="!neverEdit">Products </h3>
            </div>
            <div class="panel-toolbar">
                <router-link
                    v-if="!edit"
                    tag="button"
                    class="btn btn-sm btn-danger"
                    :to="{name: 'FastEdit', params:{id: id, fastedit: 'fastedit'} }"
                >
                Setup products and promotions
                </router-link>
            </div>
        </div>
        <div class="panel-body select-product">
            <button v-if="this.$props.fastedit === 'fastedit' && !bulk" class="btn btn-cph-primary align-self-end" type="button" @click="showFeeModal">Add fee for order</button>
            <products-add :shopProducts="allProducts" v-if="edit"></products-add>
        </div>
        <div class="panel-body">
            <vue-table ref="table" :useSearch="true"
                        v-if="!loadingState"
                        :dataTable="allProducts"
                        :defaultSortOrder="[getProductsTableSortOrder]"
                        :tableFields="TableFields"
                        @sortUpdate="sortUpdate"
                        @onSearch="onSearch"
                        :slots="slots"
                        :perPage="perPage"
                        class="products-table">

                <template slot="name" slot-scope="props">
                    <div class="names">
                        <!--<span class="display-names" v-for="format in props.data.formats" :key="format.displayName">{{format.displayString}}</span>-->
                        <span v-if="!edit">{{props.data.formats[0].displayString}}</span>
                        <input class="test-input" v-if="edit" v-model="props.data.formats[0].displayString" type="string" @focus="props.data.focused=true">
                    </div>
                </template>
                <template slot="price" slot-scope="props">
                    <span v-if="!edit">{{props.data.priceValue}}</span>
                    <input class="test-input" v-if="edit" v-model="props.data.priceValue" type="number" @focus="props.data.focused=true" @input="props.data.focused=true">
                </template>
                <template slot="order" slot-scope="props">
                    <span v-if="!edit">{{props.data.order}}</span>
                    <input class="test-input" v-if="edit" v-model="props.data.order" type="number" @focus="props.data.focused=true" @input="props.data.focused=true" @keypress="isNumber($event)">
                </template>
                <template slot="bundleSize" slot-scope="props">
                    {{props.data.bundleSize}}
                </template>
                <template slot="enable" slot-scope="props">
                    <span v-if="!edit">{{props.data.active ? 'on' : 'off' }}</span>
                    <div v-if="showToggler">
                        <vue-checkbox-toggle
                            v-if="edit"
                            ref="checkbox"
                            v-model="props.data.active"
                            @focus="props.data.focused=true"
                            @clicked="activateProduct(props.data)"
                        >
                        </vue-checkbox-toggle>
                    </div>
                </template>
                <template slot="codefield" slot-scope="props">
                    {{props.data.code !== 'undefined' ? props.data.code : '-'}}
                </template>
                <template slot="plu" slot-scope="props">
                    <span v-if="!edit">{{props.data.plu}}</span>
                    <input class="test-input" v-if="edit" v-model="props.data.plu" type="string" :maxlength="10"  @focus="props.data.focused=true">
                </template>
                <template slot="version" slot-scope="props">
                    <span v-if="!edit">{{props.data.version}}</span>
                    <input class="test-input" v-if="edit" v-model="props.data.version" type="string" :maxlength="10"  @focus="props.data.focused=true">
                </template>
                <template slot="actions" slot-scope="props">
                        <button v-if="edit" class="btn btn-sm btn-danger" v-on:click="addPromo(props)">Add promotion</button>

                      <!--  <button v-if="edit" class="btn btn-sm btn-danger" v-on:click="deleteData(props)">delete</button> -->
                        <!--<router-link class="btn btn-sm btn-info" v-for="button in buttons" :to="linkGen(button.path, props.data.id)" :key="button.name" tag="button">
                            {{button.name}}
                        </router-link>-->
                </template>
            </vue-table>
        </div>

        <div class="preloader" :class="{'active': updateCounter < 2}">
            <div class="el-loading-spinner"><svg viewBox="25 25 50 50" class="circular"><circle cx="50" cy="50" r="20" fill="none" class="path"></circle></svg><!----></div>
        </div>

    </div>
    <promotions-view
        v-if="showPromotionView && !bulk"
        @feeTableClicked="feeTableClicked"
        :orderFee="orderFee"
        @closeModal="closeModal"
        :edit="false"
        :formOpen="addPromotion"
        :selectedProduct="selectedProduct"
        v-on:close-form="closeModal"
        @saveMethod="save(allProducts, false)"
        :showadd="showadd"
        @showInformationUpdateCubes="showInformationUpdateCubes" >
    </promotions-view>
    <fee-view
        v-if="!bulk" :showModal="addFeeModal" :editFee="editFee" @closeFeeModal="closeFeeModal"
        @setFee="setFeeValue" @updateFee="updateFee" @deleteFee="deleteFee" @showInformationUpdateCubes="showInformationUpdateCubes" ></fee-view>
    <div class="panel" v-if="edit && !neverEdit">
        <div class="panel-body text-right">
            <button class="btn btn-lg btn-danger mt-2" v-on:click="save(allProducts)">SAVE</button>
        </div>
    </div>

</div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import objectPath from 'object-path';
import FeeView from '../Fee/FeeView';
import Table from '../../../components/Panel/Table/Table';
import ShopsTableFields from '../../../utilities/tablesProperties/ShopsTableFields';
import VueCheckboxToggle from '../../../components/Shared/Toggler';
import PromotionsView from '../Promotions/PromotionsView.vue';
import ProductsAdd from './ProductsAdd';
import _ from 'underscore';

export default {
    name: 'productsList',
    components: {
        'vue-table': Table,
        VueCheckboxToggle,
        PromotionsView,
        FeeView,
        ProductsAdd
    },
    props: {
        id: {
            type: String,
            default: ''
        },
        fastedit: {
            type: String,
            default: ''
        },
        hideAddition: {
            type: Boolean,
            default: false
        },
        userTableView: {
            type: Boolean,
            default: false
        },
        neverEdit:{
            type: Boolean,
            default: false
        },
        perPage:{
            type: Number,
            default: 1000
        },
        applyToShops: {
            type: Array,
            default (){
                return [];
            }
        }
    },
    watch: {
        allProducts (oldVal, newVal) {
            this.SetProductsIncludingFilters(newVal);
        },
        activeShop: {
            handler:  function () {
                this.loadProductsList(this.id).then(() => {
                    this.updateCounter++;
                });
            },
            deep: true
        },
        applyToShops (newVal) {
            this.bulk = newVal.length > 0;
        }
    },
    data () {
        return {
            bulk: false,
            selectedProduct: null,
            addPromotion: false,
            showadd: false,
            addFeeModal: false,
            orderFee: null,
            showToggler: false,
            editFee: null,
            edit: false,
            showPromotionView: true,
            slots: [
                {
                    name: 'name'
                },
                {
                    name: 'actions'
                },
                {
                    name: 'codefield'
                },
                {
                    name: 'enable'
                },
                {
                    name: 'price'
                },
                {
                    name: 'order'
                },
                {
                    name: 'plu'
                },
                {
                    name: 'bundleSize'
                },
                {
                    name: 'version'
                }
            ],
            TableFields: [
                {
                    name: 'name',
                    title: 'name',
                    sortField: 'formatDisplayString',
                    propName: 'formatDisplayString'
                },
                {
                    name: 'type',
                    title: 'Type',
                    sortField: 'type',
                    propName: 'type'
                },
                {
                    name: 'codefield',
                    title: 'code',
                    sortField: 'code',
                    propName: 'code'
                },
                {
                    name: 'bundleSize',
                    title: 'bundleSize',
                    sortField: 'bundleSize',
                    propName: 'bundleSize'
                },
                {
                    name: 'price',
                    title: 'price',
                    sortField: 'priceValue',
                    propName: 'priceValue'
                },
                {
                    name: 'order',
                    title: 'order',
                    sortField: 'orderValue',
                    propName: 'orderValue'
                },
                {
                    name: 'plu',
                    title: 'plu',
                    sortField: 'plu',
                    propName: 'plu'
                },
                {
                    name: 'enable',
                    title: 'enable',
                    sortField: 'active',
                    propName: 'active'
                },
                {
                    name: 'version',
                    title: 'version',
                    sortField: 'active',
                    propName: 'active'
                }
            ],
            buttons: {
                'show':{
                    name: 'show',
                    path: '/{{id}}',
                    icon: 'show'
                }
            },
            updateCounter: 0,
            showUpdateCubeModal: false,
        };
    },
    computed: {
        ...mapGetters({
            allProducts: 'getProducts',
            getProductsTableFilters: 'getProductsTableFilters',
            getProductsTableSortOrder: 'getProductsTableSortOrder',
            getProductsIncludingFilters: 'getProductsIncludingFilters',
            formats: 'getFormats',
            prices: 'getAllPrices',
            loadingState: 'getLoadingState',
            activeShop: 'getActiveShop'
        })
    },
    methods: {
        ...mapMutations([
            'updateProductGroupList',
            'updateLoadingState',
            'updateProducts',
            'addAlert',
            'updateUserShopList',
            'addFee'
        ]),
        ...mapActions([
            'AddProductsTableFilters',
            'SetProductsIncludingFilters',
            'loadProductsList',
            'loadProducts',
            'productsSaved',
            'setContext',
            'setFee',
        ]),
        isNumber: function (evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode === 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        feeTableClicked(data) {
            this.addFeeModal = true;
            this.editFee = data;
        },
        onSearch(data) {
            this.AddProductsTableFilters(data);
            //this.SetProductsIncludingFilters(this.allProducts);
        },
        async update (id) {
            await this.loadProductsList(id);
            this.updateLoadingState(false);
        },
        linkGen(path, id){
            return `/panel/shops${path.replace('{{id}}',id)}`;
        },
        addPromo(props){
            this.addPromotion = true;
            this.showadd = true
            this.selectedProduct = props.data;
        },
        deleteData(props){
            props.data.delete().then(() => {
                this.allProducts.splice(props.index, 1);
            });
        },
        setFeeValue(feeData) {
            this.orderFee = feeData;
            this.setFee(this.orderFee);
            this.addFeeModal = false;
        },
        showFeeModal() {
            this.addFeeModal = true;
        },
        closeModal(){
            this.addPromotion = false;
            this.showadd = false
        },
        closeFeeModal() {
            this.addFeeModal = false;
            this.editFee = null;
        },
        async activateProduct(product){
          await this.save(this.allProducts, false)
        },
        async save(products, reload = true ){
            let toSave = products;
            if(!this.bulk){
                toSave = _.filter(products, (product)=>{
                    return product.focused;
                });

                if(toSave.length)
                    this.showUpdateCubeModal = true;
            }
            if(this.bulk){
                this.showUpdateCubeModal = true;
                Promise.all(this.applyToShops.map((shop) => {
                    return this.loadProducts(shop.id).then((data) => {
                        this.applyChanges(data, toSave);
                    });
                }))
            }
            const promisess =_.map(toSave, (product)=>{
                return product.save(this.applyToShops);
            });

            if(reload)
                Promise.all(promisess).then((data) => {
                    this.productsSaved({id: this.id}).catch(err => console.log('err', err));
                    this.$router.push({
                        name: 'shopsshow',
                        params: { id: this.id, showInformationUpdateCubes: this.showUpdateCubeModal },
                    });
                });
        },
        async saveBulk(products, reload = true ){
            this.showUpdateCubeModal = true;
            let toSave = products;

            Promise.all(this.applyToShops.map((shop) => {
                return this.loadProducts(shop.id).then((data) => {
                    //this.applyChanges(data, toSave);
                });
            }))

            const promisess =_.map(toSave, (product)=>{
                return product.save(this.applyToShops);
            });

            Promise.all(promisess).then((data) => {
                this.productsSaved({id: this.id}).catch(err => console.log('err', err));
                this.$router.push({
                    name: 'shopsshow',
                    params: { id: this.id, showInformationUpdateCubes: this.showUpdateCubeModal },
                });
            });
        },
        sortUpdate () {
            this.showToggler = false;
            if(!this.showToggler) {
                this.$nextTick(() => {
                    this.showToggler = true;
                });
            }
        },
        runEdit (props){
            this.edit = true;
        },
        deleteFee (feeId) {
            this.addFeeModal = false;
            this.editFee = null;
            this.showPromotionView = false,
            this.$nextTick(() => this.showPromotionView = true);
        },
        updateFee (feeData) {
            this.orderFee = feeData;
            this.$store.commit('editFee', feeData);
            this.addFeeModal = false;
            this.editFee = null;
            this.showPromotionView = false,
            this.$nextTick(() => this.showPromotionView = true);
        },
        showInformationUpdateCubes(){
            this.showUpdateCubeModal = true
        }
    },
    updated () {
        if(!this.edit && this.$props.fastedit === 'fastedit' && this.$props.id){
            this.setContext(this.$props.id);
            this.update(this.id).then(() => {
                this.updateCounter++;
            });
            this.$store.dispatch('SetActiveShopAction', this.$props.id);
            this.showToggler = true;
            if(this.$props.id && this.$props.fastedit === 'fastedit'){
                this.edit = true;
                if(this.buttons && !this.bulk) {
                    this.TableFields.push('actions');
                }
            }
        }
    },
    created () {
        if(!this.fastedit) {
            this.updateCounter = 3;
        }

        this.updateLoadingState(true);
        if(this.applyToShops.length > 0){
            this.bulk = true;
        }
        this.setContext(this.$props.id);
        this.update(this.id).then(() => {
            this.updateCounter++;
        });
        this.$store.dispatch('SetActiveShopAction', this.$props.id);
    }
};

</script>

<style lang="scss" scoped>
    .panel
    {
        position: relative;
    }
    .container {
        margin-top: 50px;
    }

    .test-input{
        max-width: 100px;
    }

    .select-product {
        display: flex;
        flex-direction: column;
        padding-bottom: 0;
    }
    .preloader
    {
        pointer-events: none;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        background: #ffffff;
        z-index: 2;
        transition: opacity 700ms ease;

        &.active
        {
            pointer-events: all;
            opacity: 1;
        }
    }

</style>
